import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

export const path = '/calculator-tariff/project/list';

// Loadable вызывается на уровне модуля, а не в теле компонента: каждый вызов возвращает
// НОВЫЙ тип компонента, а новый тип React монтирует заново вместо обновления. Фильтры пишут
// pageNo/pageSize в строку запроса, Router на это перерисовывает поддерево — и страница
// размонтировалась бы на каждое изменение фильтра: открытый список закрывался, данные
// загружались заново.
const ProjectList = Loadable.Map({
  loader: {
    page: () => import('./page'),
  },
  loading: LoadableLoading,
  render(loaded) {
    const Page = loaded.page.default;

    return <Page />;
  },
});

const PageProjectList: React.FC = (props) => <ProjectList {...props} />;

export default PageProjectList;
